// import SignIn from "../Pages/Authentication/SignIn/SignIn";
// import TwoFaSignin from "../Pages/Authentication/SignIn/TwoFaSignIn";
// import EmailValidation from "../Pages/Authentication/SignIn/EmailValidation";
// import CompleteTwoFaSetup from "../Pages/Authentication/SignIn/CompleteTwoFaSetup";
// import NotFound from "../Pages/NotFound/NotFound";
// import ForgotPasswordInitiate from "../Pages/Authentication/ForgotPasswordInitiate/ForgotPasswordInitiate";
// import SignUp from "../Pages/Authentication/SignUp/SignUp";
// import ForgotPasswordComplete from "../Pages/Authentication/ForgotPasswordComplete/ForgotPasswordComplete";

import PublicLayout from "../layouts/PublicLayout";
import CompleteLogin from "../pages/CompleteLogin/CompleteLogin";
import CreateAccount from "../pages/CreateAccount/CreateAccount";
import EmailVerified from "../pages/EmailVerified/EmailVerified";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import Login from "../pages/Login/Login";
import VerifyEmail from "../pages/Onboarding/VerifyEmail";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import TwoFALogin from "../pages/TwoFALogin/TwoFALogin";

export default [
	{
		key: 'index-page',
		path: '/',
		routeComponent: <Login />,
	},
	{
		key: "register",
		path: '/register',
		routeComponent: <CreateAccount />
	},
	{
		key: "2fa",
		path: '/2fa/auth',
		routeComponent:
			<TwoFALogin />
	},
	{
		key: "login",
		path: '/login',
		routeComponent: <Login />
	},
	{
		key: "login-complete",
		path: '/complete/login',
		routeComponent: <CompleteLogin />
	},
	{
		key: "forgot-password",
		path: '/forgot-password',
		routeComponent:
			<ForgotPassword />
	},
	{
		key: "reset-password",
		path: '/reset-password',
		routeComponent:
			<ResetPassword />
	},
	{
		key:'email-verification',
		path:"/onboarding/:token",
		routeComponent:<VerifyEmail/>
	},
	{
		key:'email-verified',
		path:"/email-verified/:token",
		routeComponent:<EmailVerified/>
	}


];
